module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-week-row"
  }, _vm._l((_vm.week), function(day) {
    return _c('calendar-day', {
      key: day,
      attrs: {
        "day": day
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d63342f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarWeek.vue
// module id = 508
// module chunks = 0